//import external libraries
import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import config, { getCurrentBrand } from "../../../utils/config";
// import TechCardLink from "../tecnicalCard/techCard";
import TechCardTermovent from "../../tecnicalCard/techCardTermovent";
import {
  getProjectItemByAdmin,
  getTechCardStatus,
} from "../../../utils/services/projectService";

import { getInstallationType, getFineFilterType, getUnitTypeLabel } from "../../../utils/helper";
import { sizeOfUnitMapping } from "../../../utils/unitConstants";

//import internal resources and services
import {
  getProjectItem,
  getRevisions,
  activateRevision,
  deleteProjectItem,
  getModel,
} from "../../../utils/services/projectService";
import ProjectItemCard from "./ProjectItemCard";
import { setSnackbar } from "../../../actions/snackbarActions";
import { ReactComponent as MollierChartIcon } from "../../../image/MollierChartIconSmall.svg";
//import MUI components
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

import MoveUpIcon from "@mui/icons-material/MoveUp";
import ArticleIcon from "@mui/icons-material/Article";
import ViewListIcon from "@mui/icons-material/ViewList";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import { useTheme } from "@mui/material/styles";
import TechCardProlux from "../../../New Tech Card/TechCardProlux";
import { themeCtx } from "../../../utils/hooks/themeContext";

function ProjectItemRevision() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [rows, setRows] = React.useState([]);
  const [tabName, setTabName] = useState(t("projectitemrevision.all"));
  const [initialColumnsUpdated, setInitialColumnsUpdated] = useState(false);
  const [countedFetch, setCountedFetch] = useState(0);
  const { currentTheme } = useContext(themeCtx);
  const { isClivet } = useSelector((state) => state.brand);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const RenderButtonActivate = () => {
    return (
      <Box>
        <Button onClick={handleClickOpen}>
          <MoveUpIcon sx={{ color: theme.palette.primary.main }} />
        </Button>
      </Box>
    );
  };

  const [openDialogDelete, setOpenDialogDelete] = React.useState(false);

  const handleOpenDialogDelete = () => {
    setOpenDialogDelete(true);
  };

  const handleCloseDialogDelete = () => {
    setOpenDialogDelete(false);
  };

  const deleteProjectItem1 = () => {
    deleteProjectItem(projectItemId)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          dispatch(
            setSnackbar(
              true,
              "success",
              t("snackbar.deleteProjectItemSuccess"),
              "/"
            )
          );
        } else {
          dispatch(
            setSnackbar(true, "error", t("snackbar.deleteProjectItemError"))
          );
        }
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", t("snackbar.deleteProjectItemError"))
        );
      });

    handleCloseDialogDelete();
  };

  const location = useLocation();
  const [selectionModel, setSelectionModel] = useState([]);

  const [columnsToShow, setColumns] = useState([]);

  const [openPoper, setOpenPoper] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [placement, setPlacement] = useState();
  const [projectItemId, setProjectItemId] = useState();
  const [revisionActivated, setRevisionActivated] = useState(false);
  const moment = require("moment");

  const authToken = localStorage.getItem("jwt");

  const handleClickPoper = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPoper((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };
  const handleDownload = async (type, id) => {
    const endpoint = `${config.base_url}/documentation/${type}?id=${id}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
          "X-Brand": getCurrentBrand(),
        },
      });

      if (!response.ok) throw new Error("Greška pri preuzimanju PDF-a");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${type}_TechnicalCard.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Greška:", error);
    }
  };

  const handleDrawingsDownload = async (id, revNum) => {
    const endpoint = `${config.base_url}/documentation/drawings?id=${id}&revNum=${revNum}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          //"Content-Type": "application/zip",
          Authorization: `Bearer ${authToken}`,
          //"X-Brand":
        },
      });

      if (!response.ok) throw new Error("Greška pri preuzimanju crteža!");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Drawings.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Greška", error);
    }
  };

  const handleClosePopper = () => {
    setOpenPoper(false);
    setAnchorEl(null);
  };
  const canBeOpen = openPoper && Boolean(anchorEl);
  const idPoper = canBeOpen ? "transition-popper" : undefined;

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }
  const [buttonPDF, setButtonPDF] = useState(false);
  const [button3D, setButton3D] = useState(false);
  const [ThreeDLink, set3DLink] = useState("");
  const [projects, setProject] = useState([]);
  const [activePosition, setActivePosition] = useState({});
  const [loading, setLoading] = useState({
    activeItem: false,
    revisionTable: false,
  });

  const baseUnitTypeReverseMapping = {
    "Compact:Prime": 1,
    "Energy:Prime Standard": 2,
    "Energy:Prime Genius": 2,
    "Aqua:Prime Standard": 4,
    "Aqua:Prime Genius": 4,
  };

  const editProjectItem = () => {
    window.scrollTo(0, 0);
    const ahuType = baseUnitTypeReverseMapping[activePosition.unitType];
    navigate(
      `/create-project/0/configurator/${ahuType}?isEditing=true&projectItemId=${projectItemId}`,
      { replace: true }
    );
  };

  const sizeOfUnitValueFormatter = ({ value }) =>
    sizeOfUnitMapping[value] || value;

  const [numOfRows, setNumRows] = useState(0);
  /*useEffect(() => {
    if (location.state.projectItem !== undefined)
      setActivePosition(location.state.projectItem);
  }, []);*/

  useEffect(() => {
    if (initialColumnsUpdated) {
      // && location.state.projectItem === undefined
      getRevisions(projectItemId)
        .then((response) => {
          console.log(response.data);
          if (response.statusCode >= 200 && response.statusCode < 300) {
            setNumRows(response.data.data.length + 1);
            setProject(response.data.data);
          }
          return location.state.admin !== true
            ? getProjectItem(projectItemId)
            : getProjectItemByAdmin(projectItemId);
        })
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300) {
            setActivePosition({
              ...response.data,
              projectItemId: response.data.id,
            });

            setProject((prev) => [
              { projectItemId: response.data.id, ...response.data },
              ...prev,
            ]);
          }
          return getModel(response.data.id, response.data.revisionNumber);
        })
        .then((res) => {
          if (res.statusCode === 200 && res.data.data !== null) {
            setButton3D(true);
            set3DLink(res.data.data);
          }
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", t("snackbar.fetchingDataError")));
          setLoading((prev) => ({ ...prev, revisionTable: false }));
        });
    }
  }, [projectItemId, revisionActivated]);

  useEffect(() => {
    let initialColums = [];
    for (const group of columnGroupingModel) {
      initialColums.push(...group.children);
    }
    setColumns(initialColums);
    setProjectItemId(location.state.id);
    setInitialColumnsUpdated(true);
  }, []);

  /*useEffect(() => {
    if (numOfRows === projects.length && numOfRows !== 0) {
      setLoading((prev) => ({ ...prev, activeItem: false }));
      setLoading((prev) => ({ ...prev, revisionTable: false }));
    }
  }, [projects, numOfRows]);*/

  const makeRevisionActive = (e) => {
    let newRevision = activateRevision(selectionModel[0])
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          dispatch(
            setSnackbar(true, "success", t("snackbar.activateRevisionSuccess"))
          );

          setProjectItemId(response.data.id);
          setRevisionActivated((prev) => !prev);
        } else {
          dispatch(
            setSnackbar(true, "error", t("snackbar.activateRevisionError"))
          );
        }
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", t("snackbar.activateRevisionError"))
        );
      });

    handleClose();
  };

  const handleShowAll = () => {
    let initialColums = [];
    for (const group of columnGroupingModel) {
      initialColums.push(...group.children);
    }
    setColumns(initialColums);
    setTabName(t("projectitemrevision.allCol"));
  };

  //Filter za grupe polja

  const filterColumns = (columnsFilter) => {
    //Kreiranje liste grupa za prikazivanje
    let columnsGroup = ["revisionData"];
    for (const property in columnsFilter) {
      if (columnsFilter[property] === true) columnsGroup.push(property);
    }
    //Kreiranje liste kolona za prikazivanje
    const filteredList = [];

    for (const group of columnGroupingModel) {
      if (columnsGroup.includes(group.groupId)) {
        filteredList.push(...group.children);
      }
    }

    setColumns(filteredList);
  };

  //Prikaz grupa polja u tabeli na osnovu selektovanog taba
  const showFieldGroup = (selectedTab) => {
    let columnsGroup = ["revisionData"];
    switch (selectedTab) {
      case 0:
        columnsGroup.push("projectInformation");
        setTabName(t("mainform.info").toUpperCase());
        break;
      case 1:
        columnsGroup.push("requirements");
        setTabName(t("mainform.requirements").toUpperCase());
        break;
      case 2:
        columnsGroup.push("typeOfUnit");
        setTabName(t("mainform.typeOfUnit").toUpperCase());
        break;
      case 3:
        columnsGroup.push("operatingpoint");
        setTabName(t("mainform.operatingpoint").toUpperCase());
        break;
      case 4:
        columnsGroup.push("filtering");
        setTabName(t("mainform.filtering").toUpperCase());
        break;
      case 5:
        columnsGroup.push("fan");
        setTabName(t("mainform.fan").toUpperCase());
        break;
    }
    let filteredList = [];

    for (const group of columnGroupingModel) {
      if (columnsGroup.includes(group.groupId)) {
        filteredList.push(...group.children);
      }
    }
    /*filteredList.push(columnGroupingModel.filter((item) => {
      return item.groupId === columnsGroup;
    }))*/

    setColumns(filteredList);
  };

  const columnGroupingModel = [
    {
      groupId: "revisionData",
      children: [
        {
          field: "btnActivate",
          headerName: t("projectitemrevision.activate"),
          width: 130,
          renderCell: RenderButtonActivate,
          align: "center",
          headerAlign: "center",
          hideable: false,
          disableClickEventBubbling: true,
          sortable: false,
          disableColumnMenu: true,
          //headerClassName: "header-style",
        },
        {
          field: "revisionNumber",
          headerName: t("projectitemrevision.id"),
          width: 110,
          align: "center",
          headerAlign: "center",
          editable: false,
          withBorderColor: "#FF0000",
          //headerClassName: "header-style",
        },
        {
          field: "projectItemId",
          headerName: t("projectitemrevision.projectItemId"),
          width: 150,
          align: "center",
          headerAlign: "center",
          editable: false,
          sortable: false,
          disableColumnMenu: true,
          //headerClassName: "header-style",
        },

        {
          field: "createdAt",
          headerName: t("projectitemrevision.createdAt"),
          width: 180,
          align: "center",
          headerAlign: "center",
          // headerClassName: "header-style",
          valueGetter: (params) => {
            const localTime = new Date(
              new Date(params.row.createdAt).getTime() -
              params.row.timeZone * 60000
            );

            return moment(localTime).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          field: "price",
          headerName: t("projectitemrevision.price"),
          width: 170,
          align: "center",
          headerAlign: "center",
          type: "number",
          // headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value.toFixed(2)} €`,
        },
      ],
    },
    {
      groupId: "projectInformation",
      children: [
        {
          field: "area",
          headerName: t("projectitemrevision.area"),
          //headerClassName: "header-style",
          type: "number",
          width: 90,
          align: "center",
          headerAlign: "center",
          editable: false,
          // align: "left",
        },
        {
          field: "height",
          headerName: t("projectitemrevision.height"),
          type: "number",
          width: 90,
          //headerClassName: "header-style",
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "buildingType",
          headerName: t("projectitemrevision.buildingType"),
          type: "text",
          width: 290,
          align: "center",
          headerAlign: "center",
          //headerClassName: "header-style",
          editable: false,
          sortable: false,
          valueFormatter: ({ value }) => t(`buildingTypes.${value}`),
        },
        {
          field: "changeRate",
          headerName: t("projectitemrevision.changeRate"),
          type: "number",
          width: 160,
          editable: false,
          //headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "flowSupply",
          headerName: t("projectitemrevision.flowSupply"),
          type: "number",
          width: 200,
          editable: false,
          //headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "flowReturn",
          headerName: t("projectitemrevision.flowReturn"),
          type: "number",
          width: 110,
          editable: false,
          //headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dropSupply",
          headerName: t("projectitemrevision.dropSupply"),
          type: "number",
          width: 130,
          editable: false,
          //headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dropReturn",
          headerName: t("projectitemrevision.dropReturn"),
          type: "number",
          width: 110,
          editable: false,
          //headerClassName: "header-style",
          align: "center",
          headerAlign: "center",
        },
      ],
    },
    {
      groupId: "requirements",
      children: [
        {
          field: "ecoDesign",
          headerName: t("projectitemrevision.ecoDesign"),
          type: "text",
          //  headerClassName: "header-style",
          width: 110,
          align: "center",
          headerAlign: "center",
          editable: false,
          valueFormatter: ({ value }) => t(`requirementsList.${value}`),
        },
        {
          field: "maintenance",
          headerName: t("projectitemrevision.maintenance"),
          type: "text",
          width: 240,
          //  headerClassName: "header-style",
          editable: false,
          align: "center",
          headerAlign: "center",
          sortable: false,
          valueFormatter: ({ value }) => t(`requirementsList.${value}`),
        },
        {
          field: "casingQuality",
          headerName: t("projectitemrevision.casingQuality"),
          type: "text",
          align: "center",
          headerAlign: "center",
          width: 170,
          // headerClassName: "header-style",
          editable: false,
        },
      ],
    },
    {
      groupId: "typeOfUnit",
      children: [
        {
          field: "installation",
          headerName: t("projectitemrevision.installation"),
          type: "text",
          width: 190,
          align: "center",
          headerAlign: "center",
          // headerClassName: "header-style",
          editable: false,
          sortable: false,
          valueFormatter: ({ value }) => t(`unitTypeList.${getInstallationType(value)}`),
        },
        {
          field: "unitType",
          headerName: t("projectitemrevision.unitType"),
          type: "text",
          // headerClassName: "header-style",
          width: 255,
          editable: false,
          align: "center",
          headerAlign: "center",
          sortable: false,
          valueFormatter: ({ value }) => getUnitTypeLabel(value, isClivet),
        },
        {
          field: "sizeOfUnit",
          headerName: t("projectitemrevision.sizeOfUnit"),
          valueFormatter: sizeOfUnitValueFormatter,
          type: "text",
          // headerClassName: "header-style",
          width: 170,
          align: "center",
          headerAlign: "center",
          editable: false,
          sortable: false,
        },
        {
          field: "heatRecovery",
          headerName: t("projectitemrevision.heatRecovery"),
          type: "text",
          width: 190,
          align: "center",
          headerAlign: "center",
          // headerClassName: "header-style",
          editable: false,
          sortable: false,
          valueFormatter: ({ value }) => t(`unitTypeList.${value}`),
        },

        {
          field: "unitDivision",
          headerName: t("projectitemrevision.unitDivision"),
          type: "text",
          width: 190,
          align: "center",
          headerAlign: "center",
          // headerClassName: "header-style",
          editable: false,
          sortable: false,
          valueFormatter: ({ value }) => t(`unitTypeList.${value}`),
        },
      ],
    },
    {
      groupId: "operatingpoint",
      children: [
        {
          field: "summerOutdoorHumidity",
          headerName: t("projectitemrevision.summerRelativeHumidity"),
          type: "number",
          width: 200,
          editable: false,
          // headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "summerWetBulbTemperature",
          headerName: t("projectitemrevision.summerWetBulbTemperature"),
          type: "number",
          width: 210,
          editable: false,
          // headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "summerOutdoorTemperature",
          headerName: t("projectitemrevision.summerDryBulbTemperature"),
          type: "number",
          width: 210,
          editable: false,
          // headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "summerDewPointTemperature",
          headerName: t("projectitemrevision.summerDewPointTemperature"),
          type: "number",
          width: 190,
          // headerClassName: "header-style",
          editable: false,
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "summerIndoorTemperature",
          headerName: t("projectitemrevision.summerIndoorTemperature"),
          type: "number",
          width: 270,
          // headerClassName: "header-style",
          editable: false,
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "summerIndoorHumidity",
          headerName: t("projectitemrevision.summerIndoorHumidity"),
          type: "number",
          width: 340,
          // headerClassName: "header-style",
          editable: false,
          valueFormatter: ({ value }) => `${value} %`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "winterOutdoorTemperature",
          headerName: t("projectitemrevision.winterOutdoorTemperature"),
          type: "number",
          width: 250,
          // headerClassName: "header-style",
          editable: false,
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "winterOutdoorHumidity",
          headerName: t("projectitemrevision.winterOutdoorHumidity"),
          type: "number",
          width: 280,
          editable: false,
          // headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} %`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "winterIndoorTemperature",
          headerName: t("projectitemrevision.winterIndoorTemperature"),
          type: "number",
          width: 210,
          editable: false,
          //headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} °C`,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "winterIndoorHumidity",
          headerName: t("projectitemrevision.winterIndoorHumidity"),
          type: "number",
          width: 270,
          editable: false,
          //headerClassName: "header-style",
          valueFormatter: ({ value }) => `${value} %`,
          align: "center",
          headerAlign: "center",
        },
      ],
    },
    {
      groupId: "filtering",
      children: [
        {
          field: "fineFilterType",
          headerName: t("projectitemrevision.fineFilterType"), //proveriti
          type: "text",
          width: 220,
          align: "center",
          headerAlign: "center",
          //headerClassName: "header-style",
          editable: false,
          valueFormatter: () => getFineFilterType(activePosition.unitType)
        },

        {
          field: "fineFilterClassSupply",
          headerName: t("filtering.supplyFilter"),
          type: "text",
          width: 190,
          // headerClassName: "header-style",
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "fineFilterClassReturn",
          headerName: t("filtering.returnFilter"),
          type: "text",
          width: 190,
          // headerClassName: "header-style",
          editable: false,
          align: "center",
          headerAlign: "center",
        },
      ],
    },
    {
      groupId: "fan",
      children: [
        {
          field: "fanAdvancedSettings",
          headerName: t("projectitemrevision.fanAdvancedSettings"), //proveriti
          type: "text",
          width: 250,
          //headerClassName: "header-style",
          editable: false,
          valueFormatter: ({ value }) => t(`fanType.${value}`),
          align: "center",
          headerAlign: "center",
        },
        {
          field: "fanType",
          headerName: t("projectitemrevision.fanType"),
          type: "text",
          // headerClassName: "header-style",
          width: 200,
          editable: false,
          valueFormatter: ({ value }) => t(`fanType.${value}`),
          align: "center",
          headerAlign: "center",
        },
      ],
    },
  ];

  const [documentationExist, setDocumentationExist] = useState(false);
  const [renderAgain, setRerender] = useState(false);

  /* const fetchTechCardData = () => {
    setDocumentationExist(false);
    setCountedFetch(countedFetch + 1);
    getTechCardStatus(activePosition.id, activePosition.revisionNumber)
      .then((res) => {
        if (res.data.data) setDocumentationExist(true);
        else {
          if (countedFetch < 24)
            setTimeout(() => {
              setRerender(!renderAgain);
            }, 5000);
          else {
            setTimeout(() => {
              setRerender(!renderAgain);
            }, 300000);
          }
        }
      })
      .catch((err) => {
        console.log("Desila se greske pri kreiranju dokumentacije");
      });
  }; */

  /* useEffect(() => {
    fetchTechCardData();
  }, [renderAgain, revisionActivated]);*/

  return loading.activeItem === false && loading.revisionTable === false ? (
    <>
      <Container component="main" maxWidth sx={{ mb: 4 }}>
        <Box sx={{ height: "40%", mt: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <ArticleIcon sx={{ width: 50, height: 50 }} />
              <Typography component="h1" variant="h5" sx={{ margin: 2 }}>
                {t("projectitemrevision.activeposition")}: {activePosition.name}
              </Typography>
              <Box>
                {button3D && (
                  <Button>
                    {" "}
                    <ThreeDRotationIcon
                      onClick={() => {
                        window.open(ThreeDLink);
                      }}
                      sx={{ color: theme.palette.primary.main }}
                    />
                  </Button>
                )}
                <Button
                  onClick={() =>
                    handleDownload(
                      "techcard",
                      location.state.projectItem !== undefined
                        ? location.state.id
                        : activePosition.id

                    )
                  }
                >
                  Generate PDF
                </Button>
                <Button
                  onClick={() =>
                    handleDownload(
                      "hx",
                      location.state.projectItem !== undefined
                        ? location.state.id
                        : activePosition.id
                    )
                  }
                >
                  Mollier h-x diagram
                </Button>
                {window.location.hostname.includes("prolux") && (
                  <Button
                    onClick={() =>
                      handleDownload(
                        "prolux",
                        location.state.projectItem !== undefined
                          ? location.state.id
                          : activePosition.id,
                        location.state.projectItem !== undefined
                          ? location.state.projectItem.revisionNumber
                          : activePosition.revisionNumber
                      )
                    }
                  >
                    Prolux PDF
                  </Button>
                )}
                <Button
                  onClick={() =>
                    handleDrawingsDownload(
                      location.state.projectItem !== undefined
                        ? location.state.id
                        : activePosition.id,
                      location.state.projectItem !== undefined
                        ? location.state.projectItem.revisionNumber
                        : activePosition.revisionNumber
                    )
                  }
                >
                  Drawings
                </Button>

                {/* {
                  <>
                     <Button>
                      <TechCardTermovent
                        heatRecovery={
                          location.state.projectItem !== undefined
                            ? location.state.projectItem.heatRecovery
                            : activePosition.heatRecovery
                        }
                        id={
                          location.state.projectItem !== undefined
                            ? location.state.card.projectItemId
                            : activePosition.id
                        }
                        revNum={
                          location.state.projectItem !== undefined
                            ? location.state.projectItem.revisionNumber
                            : activePosition.revisionNumber
                        }
                        cardContent={location.state.card}
                        admin={location.state.admin}
                        //docName={docName}
                      />
                    </Button>

                    {currentTheme == true && (
                      <Button>
                        <TechCardProlux
                          heatRecovery={
                            location.state.projectItem !== undefined
                              ? location.state.projectItem.heatRecovery
                              : activePosition.heatRecovery
                          }
                          id={
                            location.state.projectItem !== undefined
                              ? location.state.card.projectItemId
                              : activePosition.id
                          }
                          revNum={
                            location.state.projectItem !== undefined
                              ? location.state.projectItem.revisionNumber
                              : activePosition.revisionNumber
                          }
                          cardContent={location.state.card}
                          admin={location.state.admin}
                        />
                      </Button> 
                    )}
                  </>
                } */}
              </Box>
            </Box>
            <Box sx={{ flex: "1", textAlign: "right", paddingRight: "35px" }}>
              <Button onClick={() => editProjectItem()}>
                <EditIcon sx={{ color: theme.palette.primary.main }} />
              </Button>

              <Button onClick={handleOpenDialogDelete}>
                {" "}
                <DeleteIcon sx={{ color: theme.palette.primary.main }} />
              </Button>
            </Box>
          </Box>

          <Dialog
            disableScrollLock={true}
            open={openDialogDelete}
            onClose={handleCloseDialogDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { padding: "10px 20px" } }}
            sx={{ backdropFilter: "blur(5px)" }}
          >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: "30px" }}>
              {t("projectitem.dialogTitle")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                sx={{ fontSize: "20px", color: "#222" }}
              >
                {t("projectitem.dialogContentText")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDialogDelete}
                variant="outlined"
                sx={{
                  fontSize: "18px",
                  marginRight: "5px",
                  padding: "2px",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    color: theme.palette.secondary.main,
                  },
                }}
              >
                {t("projectitem.buttonNo")}
              </Button>
              <Button
                onClick={() => deleteProjectItem1()}
                autoFocus
                variant="outlined"
                sx={{
                  fontSize: "18px",
                  padding: "2px",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    color: theme.palette.secondary.main,
                  },
                }}
              >
                {t("projectitem.buttonYes")}
              </Button>
            </DialogActions>
          </Dialog>

          <Divider sx={{ mb: 3 }} />
        </Box>
        <ProjectItemCard
          projId={activePosition.projId}
          projIdent={activePosition.projIdent}
          projName={activePosition.projName}
          projNumber={activePosition.projNumber}
          area={activePosition.area}
          height={activePosition.height}
          buildingType={activePosition.buildingType}
          changeRate={activePosition.changeRate}
          dropSupply={activePosition.dropSupply}
          flowSupply={activePosition.flowSupply}
          flowReturn={activePosition.flowReturn}
          dropReturn={activePosition.dropReturn}
          ecoDesign={activePosition.ecoDesign}
          maintenance={activePosition.maintenance}
          casingQuality={activePosition.casingQuality}
          installation={activePosition.installation}
          unitType={activePosition.unitType}
          heatRecovery={activePosition.heatRecovery}
          controls={activePosition.controls}
          unitSize={activePosition.sizeOfUnit}
          unitDivision={activePosition.unitDivision}
          summerOutdoorTemperature={activePosition.summerOutdoorTemperature}
          summerWetBulbTemperature={activePosition.summerWetBulbTemperature}
          summerDewPointTemperature={activePosition.summerDewPointTemperature}
          summerOutdoorHumidity={activePosition.summerOutdoorHumidity}
          summerIndoorTemperature={activePosition.summerIndoorTemperature}
          summerIndoorHumidity={activePosition.summerIndoorHumidity}
          summerSupplyTemperature={activePosition.summerSupplyTemperature}
          coolerType={activePosition.coolerType}
          coolerConcentration={activePosition.coolerConcentration}
          coolerTemperatureIn={activePosition.coolerTemperatureIn}
          coolerTemperatureOut={activePosition.coolerTemperatureOut}
          winterOutdoorTemperature={activePosition.winterOutdoorTemperature}
          winterOutdoorHumidity={activePosition.winterOutdoorHumidity}
          winterIndoorTemperature={activePosition.winterIndoorTemperature}
          winterIndoorHumidity={activePosition.winterIndoorHumidity}
          heaterType={activePosition.heaterType}
          heaterConcentration={activePosition.heaterConcentration}
          heaterTemperatureIn={activePosition.heaterTemperatureIn}
          fineFilterType={activePosition.fineFilterType}
          fineFilterClassSupply={activePosition.fineFilterClassSupply}
          fineFilterClassReturn={activePosition.fineFilterClassReturn}
          fanAdvancedSettings={activePosition.fanAdvancedSettings}
          fanType={activePosition.fanType}
          fieldGroup={showFieldGroup}
          coils={activePosition.coils}
          coolerAirInputParam={activePosition.coolerAirInputParam}
          coolerAirInputParamValue={activePosition.coolerAirInputParamValue}
          coolerWaterInputParam={activePosition.coolerWaterInputParam}
          coolerWaterInputParamValue={activePosition.coolerWaterInputParamValue}
          heaterAirInputParam={activePosition.heaterAirInputParam}
          heaterAirInputParamValue={activePosition.heaterAirInputParamValue}
          heaterWaterInputParam={activePosition.heaterWaterInputParam}
          heaterWaterInputParamValue={activePosition.heaterWaterInputParamValue}
        ></ProjectItemCard>
      </Container>
      <Box sx={{ height: "40%", mt: 1 }}>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <ViewListIcon sx={{ width: 50, height: 50 }} />
          <Typography component="h1" variant="h5" sx={{ margin: 2 }}>
            {t("projectitemrevision.tabname")}
          </Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />
      </Box>
      <Grid container direction="row" pb={2}>
        <Button disabled>
          {t("projectitemrevision.group")}: {tabName}{" "}
        </Button>

        <Button variant="outlined" onClick={handleShowAll}>
          {t("projectitemrevision.showAll")}
        </Button>
      </Grid>

      <div style={{ height: "500px", mb: "50px", width: "100%" }}>
        <DataGrid
          rows={projects}
          sx={{
            'div[data-rowIndex][role="row"]:first-of-type)': {
              backgroundColor: "rgb(128, 202, 239)",
            },
            'div[data-rowIndex][role="row"]:first-of-type button': {
              display: "none",
            },
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.secondary.main,
            },
            ".MuiTablePagination-select": {
              "margin-top": "-3px",
            },
            ".MuiTablePagination-selectIcon": {
              "margin-top": "-3px",
            },
            ".MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle":
            {
              fontWeight: "bold",
              paddingLeft: "5px",
            },
          }}
          columns={columnsToShow}
          rowsPerPageOptions={[10, 20, 100]}
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
          {...rows}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {t("projectitemrevision.noRows")}
              </Stack>
            ),
          }}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: t("tableRows.rowsPerPage"),
              labelDisplayedRows: ({ from, to, count }) =>
                `${from} - ${to} ${t("tableRows.of")} ${count}`,
            },
          }}
        ></DataGrid>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("revisionDialog.dialogTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("revisionDialog.dialogContentText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("revisionDialog.buttonNo")}</Button>
          <Button onClick={(e) => makeRevisionActive(e)} autoFocus>
            {t("revisionDialog.buttonYes")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : (
    <Box sx={{ width: "100%", height: "75vh" }}>
      <Stack
        spacing={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Skeleton
          variant="rectangular"
          sx={{ width: "60%", height: "20vh", my: "5%" }}
        />

        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
      </Stack>
    </Box>
  );
}

ProjectItemRevision.whyDidYouRender = true;

export default ProjectItemRevision;
